export default __webpack_public_path__ + "static/media/location.bc34c7b0.svg";